import i18n from "i18n";
import { useEffect, useState } from "react";

export const useOnLanguageChange = () => {
  const [savedLanguage, changeLanguage] = useState(i18n.language);

  useEffect(() => {
    const eventListener = (l: string) => changeLanguage(l);

    i18n.on("languageChanged", eventListener);

    return () => i18n.off("languageChanged", eventListener);
  }, []);

  return savedLanguage;
};
